(async function () {
    // save the section id from the script tag and find the section
    const sectionID = document.currentScript.dataset.id;
    const section = document.querySelector(`#${sectionID}`);

    // exit if section is not found
    if (!section) {
        console.warn(`Product section with ID ${sectionID} not found.`);
        return;
    }

    // get the key values from the section
    const product = JSON.parse(section.querySelector(".productJSON").textContent);
    let activeVariant = JSON.parse(section.querySelector(".productVariantJSON").textContent);
    let quantity = 1;

    // during dev mode, set the active variant to the window so it can be accessed in the console
    if (Shopify.theme.role === "development") {
        window.product = product;
        window.activeVariant = activeVariant;
    }

    /**************
     Update Product
     ***************/

    // update active variant on input changes
    section.querySelectorAll("input, select").forEach(function (element) {
        element.addEventListener("change", function () {
            updateProduct().catch(e => console.error(e));
        });
    })

    function isSubscription() {
        return !!section.querySelector(`.productFormSellingOptionHeaderInput:checked`) === true;
    }

    function currentSellingPlan() {
        return parseInt(section.querySelector('.productFormOptionsItemValuesLabelInput:checked').dataset.id);
    }

    let firstRun = true;

    /* ========= MOBILE SLIDER ========= */
const mobileGallery = document.getElementById('MobileGallery');
const track = document.getElementById('MobileSliderTrack');
const slides = [...track.querySelectorAll('.media-slide')];
const thumbs = [...document.querySelectorAll('#MobileThumbs .media-thumb')];
const counter = document.getElementById('MobileIndex');

const prevBtn = mobileGallery.querySelector('.media-arrow.prev');
const nextBtn = mobileGallery.querySelector('.media-arrow.next');

let mobileIndex = 0;

/* Get width of ONE slide */
function slideWidth() {
  return slides[0].getBoundingClientRect().width;
}

function syncMobile(index, smooth = true) {
  mobileIndex = index;

  track.scrollTo({
    left: slideWidth() * index,
    behavior: smooth ? 'smooth' : 'auto'
  });

  counter.textContent = index + 1;

  thumbs.forEach(t => t.classList.remove('is-active'));
  if (thumbs[index]) thumbs[index].classList.add('is-active');
}

/* Thumbs */
thumbs.forEach((thumb, i) => {
  thumb.addEventListener('click', () => {
    syncMobile(i);
  });
});

/* Arrows */
prevBtn.addEventListener('click', () => {
  if (mobileIndex > 0) syncMobile(mobileIndex - 1);
});

nextBtn.addEventListener('click', () => {
  if (mobileIndex < slides.length - 1) syncMobile(mobileIndex + 1);
});

/* Swipe / scroll sync */
track.addEventListener('scroll', () => {
  const i = Math.round(track.scrollLeft / slideWidth());
  if (i !== mobileIndex) {
    mobileIndex = i;
    counter.textContent = i + 1;

    thumbs.forEach(t => t.classList.remove('is-active'));
    if (thumbs[i]) thumbs[i].classList.add('is-active');
  }
});

function updateMobileFeaturedImage(variant) {
  if (!variant || !variant.featured_media) return;

  const featuredSrc = variant.featured_media.preview_image.src;

  // First slide image
  const firstSlideImg = document.querySelector(
    '#MobileSliderTrack .media-slide:first-child img'
  );

  // First thumb image
  const firstThumbImg = document.querySelector(
    '#MobileThumbs .media-thumb:first-child img'
  );

  if (firstSlideImg) {
    firstSlideImg.src = featuredSrc;
    firstSlideImg.srcset = featuredSrc;
  }

  if (firstThumbImg) {
    firstThumbImg.src = featuredSrc;
    firstThumbImg.srcset = featuredSrc;
  }

  // Reset slider to first slide
  syncMobile(0, false);
}

  /* ========= DESKTOP MODAL (FIXED) ========= */
const modal = document.getElementById('MediaModal');
const modalImg = document.getElementById('ModalImage');
const modalOverlay = modal.querySelector('.media-modal-overlay');
const modalClose = modal.querySelector('.modal-close');
const modalPrev = modal.querySelector('.modal-arrow.prev');
const modalNext = modal.querySelector('.modal-arrow.next');

const gridImages = [...document.querySelectorAll('.media-grid-item img')];

let modalIndex = 0;

function openModal(index) {
  modalIndex = index;
  modalImg.src = gridImages[modalIndex].src;
  modal.classList.add('is-open');
  modal.setAttribute('aria-hidden', 'false');
  document.body.style.overflow = 'hidden';
}

function closeModal() {
  modal.classList.remove('is-open');
  modal.setAttribute('aria-hidden', 'true');
  document.body.style.overflow = '';
}

/* Open */
document.querySelectorAll('.js-open-modal').forEach((btn, i) => {
  btn.addEventListener('click', () => openModal(i));
});

/* Prev */
modalPrev.addEventListener('click', function (e) {
  e.preventDefault();
  e.stopPropagation();

  modalIndex = Math.max(0, modalIndex - 1);
  modalImg.src = gridImages[modalIndex].src;
});

/* Next */
modalNext.addEventListener('click', function (e) {
  e.preventDefault();
  e.stopPropagation();

  modalIndex = Math.min(gridImages.length - 1, modalIndex + 1);
  modalImg.src = gridImages[modalIndex].src;
});

/* Close */
modalOverlay.addEventListener('click', closeModal);
modalClose.addEventListener('click', closeModal);

    async function updateProduct() {
        // Find the active variant
        if (product.variants.length === 1) {
            // default fallback
            activeVariant = product.variants[0];
        } else {
            // collect options from inputs
            let options = [];
            section.querySelectorAll(`.productFormOptionsItem`).forEach(group => {
                if (group.querySelector(`input:checked`).classList.contains('productFormSellingOptionHeaderInput')) return;
                options.push(group.querySelector(`input:checked`).value);
            });
            // find new variant based on the options
            activeVariant = product.variants.find((variant) => {
                return JSON.stringify(variant.options) === JSON.stringify(options)
            });
        }

        // check if variant wasn't found
        if (!activeVariant) {
            section.querySelector(".productATC").disabled = true;
            section.querySelector(".productATCText").textContent = "Not Available";
            return;
        }

        // update dynamic pay button
        document.querySelector('#productDynamicInput').value = activeVariant.id;

        // go to image if exists
        if (activeVariant.featured_image) {
            document.getElementById('DesktopHeroImage').src = activeVariant.featured_media.preview_image.src;
            updateMobileFeaturedImage(activeVariant);
        }

        // update prices
        section.querySelectorAll('.productFormOptionsItemValuesLabel')?.forEach(element => {
            // find the variant associated with this label
            let variant = JSON.parse(element.dataset.variant);
            let total = variant.price;
            let compare = variant.compare_at_price || 0;

            if (isSubscription()) {
                total = variant.selling_plan_allocations[0].price
                // metafield overwrites sub compare for some products
                if (!element.classList.contains('compare')) {
                    compare = variant.selling_plan_allocations[0].compare_at_price || 0;
                }
            }
            let save = compare - total;

            // update the prices
            // element.querySelector('.productFormOptionsItemValuesLabelRightPrice').textContent = price(total);
            // element.querySelector('.productFormOptionsItemValuesLabelRightCompare').textContent = '';
            // element.querySelector('.productFormOptionsItemValuesLabelLeftSave').textContent = '';

            if (compare > total) {
                // element.querySelector('.productFormOptionsItemValuesLabelRightCompare').textContent = price(compare);
                // element.querySelector('.productFormOptionsItemValuesLabelLeftSave').textContent = `Save ${price(save)}`;
            }
        })

        let total = activeVariant.price;
        let compare = activeVariant.compare_at_price || 0;
        if (isSubscription()) {
            total = activeVariant.selling_plan_allocations[0].price
            // compare = activeVariant.selling_plan_allocations[0].compare_at_price || 0;
        }
        
        let save = compare - total;
        section.querySelectorAll('.productPriceReal').forEach(element => {
          element.textContent = price(total);
        });
        section.querySelector('.productPriceCompare').textContent = '';
        // section.querySelector('.productPriceSavings').textContent = '';
        if (compare > total) {
            section.querySelector('.productPriceCompare').textContent = price(compare)
            // section.querySelector('.productPriceSavings').textContent = `Save ${price(save)}`;
        }

        /**************
         ATC Enable/Disable
         ***************/

        // enable the atc button
        section.querySelector(".productATC").disabled = false;

        // check if the variant is in stock
        if (activeVariant.available) {
            section.querySelector(".productATC").classList.remove("oos");
            section.querySelector(".productATCText").textContent = "Add To Cart";
        } else {
            section.querySelector(".productATC").classList.add("oos");
            section.querySelector(".productATCText").textContent = "Email me when back in stock";
        }


        // section.querySelector('.productATCPrice').textContent = price(total);

        // update url with variant id so the selected options are maintained on refresh
        let url = new URL(window.location.href);
        url.searchParams.set("variant", activeVariant.id);
        window.history.replaceState({}, "", url);
    }

    // on load, update the product
    // this accomplishes loading the correct variant image and price on page load
    await updateProduct().catch(e => console.error(e));

    firstRun = false;

    /**************
     Product ATC
     ***************/

    section.querySelector('.productATC').addEventListener("click", async function () {
        // if button is oos, open swal
        if (this.classList.contains("oos")) {
            // swal request email
            const {value: email} = await Swal.fire({
                title: 'Notify me back in stock',
                input: 'email',
                inputPlaceholder: 'Email Address',
                confirmButtonText: 'Notify Me',
                showCancelButton: true,
            });

            // if no email, exit
            if (!email) {
                return;
            }

            // send to klaviyo
            sendKlaviyoBackInStockRequest(email, activeVariant.id);

            // show success message
            await Swal.fire({
                title: 'Success!',
                text: 'You will be notified when this product is back in stock.',
                confirmButtonText: 'OK',
            });

            return;
        }

        // add loading animation to both buttons
        section.querySelector(".productATC").classList.add("loading");

        let formData = {
            items: [{
                quantity: 1,
                id: activeVariant.id,
            }]
        };

        // check for selling plan
        if (isSubscription()) {
            formData.items[0].selling_plan = currentSellingPlan()
        }

        // add product
        await addProduct(formData);

        // remove loading animation
        section.querySelector(".productATC").classList.remove("loading");

        // open cart
        await openCart();
    });

    /** Block - Dropdown **/

    // setup dropdowns
    section.querySelectorAll(".productDropsItemButton").forEach(element => {
        element.addEventListener("click", function () {
            this.classList.toggle("active");
        });
    });
}());

(function(){
    var out = document.getElementById('ship-date-by');
    if(!out) return;

    var days = 2;
    var d = new Date();
    d.setDate(d.getDate() + days);

    var fmt = new Intl.DateTimeFormat(undefined, {
      weekday: 'short', month: 'short', day: 'numeric'
    });

    out.textContent = fmt.format(d).trim();
})();

(function () {
  function ready(fn){ document.readyState !== 'loading' ? fn() : document.addEventListener('DOMContentLoaded', fn); }

  ready(function () {
    const form = document.getElementById('productDynamic');
    if (!form) return;

    const sellingPlanHidden = form.querySelector('#subscriptionSellingPlan');
    if (!sellingPlanHidden) return;

    const optionRadios = Array.from(document.querySelectorAll('.productFormOptionsItemValuesLabelInput'));
    const subLabel = document.querySelector('.productFormSellingOption');
    const subCheckbox = subLabel ? subLabel.querySelector('.productFormSellingOptionHeaderInput') : null;

    if (!optionRadios.length || !subCheckbox) return;

    // ---- helpers ----
    const getCurrentRadio = () => optionRadios.find(r => r.checked) || optionRadios[0] || null;
    const getPlanFromRadio = (radio) => (radio && radio.dataset && radio.dataset.id) ? radio.dataset.id : '';

    // Remembered plan id (used when toggling subscription off/on)
    let rememberedPlanId = '';

    // ---- INIT ----
    // If you want the *second* radio as the initial source, prefer that; fall back to checked one.
    const initialRadio = optionRadios[1] || getCurrentRadio();
    rememberedPlanId = getPlanFromRadio(initialRadio);

    if (subCheckbox.checked) {
      // Subscription ON at load: push plan id into hidden
      sellingPlanHidden.value = rememberedPlanId;
    } else {
      // Subscription OFF at load: clear hidden
      sellingPlanHidden.value = '';
    }

    // ---- RADIO CHANGES ----
    // Always keep the "remembered" plan id in sync with the currently selected radio.
    // If subscription is ON, also push it into the hidden input immediately.
    optionRadios.forEach(radio => {
      radio.addEventListener('change', function () {
        rememberedPlanId = getPlanFromRadio(this);
        if (subCheckbox.checked) {
          sellingPlanHidden.value = rememberedPlanId; // may be '' for one-time options
        }
      });
    });

    // Some themes switch radios on label click without firing 'change' immediately;
    // this keeps behavior snappy. (Safe no-op if change already fires.)
    const optionLabels = Array.from(document.querySelectorAll('.productFormOptionsItemValuesLabel'));
    optionLabels.forEach(label => {
      label.addEventListener('click', function () {
        const radio = this.querySelector('.productFormOptionsItemValuesLabelInput');
        if (!radio) return;
        rememberedPlanId = getPlanFromRadio(radio);
        if (subCheckbox.checked) {
          sellingPlanHidden.value = rememberedPlanId;
        }
      });
    });

    // ---- SUBSCRIPTION TOGGLE ----
    // When turning OFF: remember current plan (from hidden or current radio), then clear hidden.
    // When turning ON: restore remembered plan (or pull from current radio if empty).
    subCheckbox.addEventListener('change', function () {
      const currentRadio = getCurrentRadio();
      const currentPlanFromRadio = getPlanFromRadio(currentRadio);

      if (!this.checked) {
        // OFF → store what's currently active (prefer hidden, otherwise from radio)
        rememberedPlanId = sellingPlanHidden.value || currentPlanFromRadio || '';
        sellingPlanHidden.value = ''; // clear to indicate one-time purchase
      } else {
        // ON → restore (prefer remembered; if somehow empty, use current radio)
        if (!rememberedPlanId) rememberedPlanId = currentPlanFromRadio || '';
        sellingPlanHidden.value = rememberedPlanId;
      }
    });

    // Also respond to clicks on the wrapping label (in case browser toggles via label)
    if (subLabel) {
      subLabel.addEventListener('click', function (e) {
        // Let the checkbox toggle first, then run the same logic (microtask delay)
        setTimeout(() => {
          const currentRadio = getCurrentRadio();
          const currentPlanFromRadio = getPlanFromRadio(currentRadio);

          if (!subCheckbox.checked) {
            rememberedPlanId = sellingPlanHidden.value || currentPlanFromRadio || '';
            sellingPlanHidden.value = '';
          } else {
            if (!rememberedPlanId) rememberedPlanId = currentPlanFromRadio || '';
            sellingPlanHidden.value = rememberedPlanId;
          }
        }, 0);
      });
    }
  });
})();

document.addEventListener('DOMContentLoaded', () => {
  const stickyAtc = document.getElementById('sticky-atc');
  const stickyAtcBtn = document.querySelector('.stickyAtcBtn');
  const targetBtn = document.getElementById('product-atc');

  if (!stickyAtc || !targetBtn) return;

  if (stickyAtcBtn && targetBtn) {
    stickyAtcBtn.addEventListener('click', function () {
        targetBtn.click();
    });
    }

  function updateSticky() {
    const rect = targetBtn.getBoundingClientRect();
    const windowHeight = window.innerHeight || document.documentElement.clientHeight;

    // Show sticky CTA only when button has been scrolled PAST (above the viewport)
    if (rect.top < 0 && rect.bottom < 0) {
      stickyAtc.classList.add('show');
    } else {
      stickyAtc.classList.remove('show');
    }
  }

  // Run once on load
  updateSticky();

  // Update on scroll / resize / touch
  window.addEventListener('scroll', updateSticky, { passive: true });
  window.addEventListener('resize', updateSticky);
  window.addEventListener('touchmove', updateSticky, { passive: true });
});

document.addEventListener('DOMContentLoaded', () => {
  const AtcBtns = document.querySelectorAll('.para-atc-button'); // all sticky ATC <a> buttons
  const targetBtn = document.getElementById('product-atc');      // real ATC button

  if (!AtcBtns.length || !targetBtn) return;

  AtcBtns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      e.preventDefault();     // ⛔ stop link redirect
      e.stopPropagation();    // ⛔ stop bubbling
      targetBtn.click();      // ✅ trigger real ATC
    });
  });
});

(function () {
  const accordions = document.querySelectorAll('.product-info-accordion');

  accordions.forEach(acc => {
    const header = acc.querySelector('.accordion-header');
    const content = acc.querySelector('.accordion-content');

    header.addEventListener('click', () => {
      const isOpen = header.getAttribute('aria-expanded') === 'true';

      header.setAttribute('aria-expanded', !isOpen);
      acc.classList.toggle('is-open');

      if (!isOpen) {
        // OPEN
        content.style.maxHeight = content.scrollHeight + 'px';
      } else {
        // CLOSE
        content.style.maxHeight = '0px';
      }
    });

    // Handle dynamic content (images loading)
    const images = acc.querySelectorAll('img');
    images.forEach(img => {
      img.addEventListener('load', () => {
        if (acc.classList.contains('is-open')) {
          content.style.maxHeight = content.scrollHeight + 'px';
        }
      });
    });
  });
})();

(function () {
  const propolisOptions = document.querySelectorAll('.propolis-option');

  propolisOptions.forEach(option => {
    const header = option.querySelector('.propolis-option-header');

    header.addEventListener('click', () => {
      if (option.classList.contains('propolis-disabled')) return;

      propolisOptions.forEach(o => o.classList.remove('propolis-active'));
      option.classList.add('propolis-active');

      const radio = option.querySelector('input[type="radio"]');
      if (radio) radio.checked = true;
    });
  });
  const content = document.getElementById('ProductContent');
  if (!content) return;

  const NORMAL_TOP = 16; // 1rem
  const BOTTOM_GAP = 16;

  let lastScrollY = window.scrollY;

  function updateStickyTop(forceTop = false) {
    const viewportHeight = window.innerHeight;
    const contentHeight = content.offsetHeight;

    if (contentHeight <= viewportHeight) {
      content.style.top = `${NORMAL_TOP}px`;
      return;
    }

    if (forceTop) {
      // Show TOP of content first
      content.style.top = `${NORMAL_TOP}px`;
    } else {
      // Show BOTTOM of content first
      const bottomFirstTop = viewportHeight - contentHeight - BOTTOM_GAP;
      content.style.top = `${bottomFirstTop}px`;
    }
  }

  // Initial state → show bottom first
  updateStickyTop(false);

  window.addEventListener('scroll', () => {
    const currentScrollY = window.scrollY;
    const scrollingUp = currentScrollY < lastScrollY;

    if (scrollingUp) {
      updateStickyTop(true);   // show TOP first
    } else {
      updateStickyTop(false);  // show BOTTOM first
    }

    lastScrollY = currentScrollY;
  });

  window.addEventListener('resize', () => updateStickyTop(false));

  // Handles dynamic height changes (variants, accordions)
  const observer = new ResizeObserver(() => updateStickyTop(false));
  observer.observe(content);
})();
